import { render, staticRenderFns } from "./nbdt-list.vue?vue&type=template&id=4e8c8fa3&scoped=true"
import script from "./nbdt-list.vue?vue&type=script&lang=js"
export * from "./nbdt-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c8fa3",
  null
  
)

export default component.exports